var components
try {
  components = {
    uSubsection: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-subsection/u-subsection" */ "@/uni_modules/uview-ui/components/u-subsection/u-subsection.vue"
      )
    },
    uLoadmore: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-loadmore/u-loadmore" */ "@/uni_modules/uview-ui/components/u-loadmore/u-loadmore.vue"
      )
    },
    uEmpty: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-empty/u-empty" */ "@/uni_modules/uview-ui/components/u-empty/u-empty.vue"
      )
    },
    uModal: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-modal/u-modal" */ "@/uni_modules/uview-ui/components/u-modal/u-modal.vue"
      )
    },
    uForm: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-form/u-form" */ "@/uni_modules/uview-ui/components/u-form/u-form.vue"
      )
    },
    uFormItem: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-form-item/u-form-item" */ "@/uni_modules/uview-ui/components/u-form-item/u-form-item.vue"
      )
    },
    "u-Textarea": function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u--textarea/u--textarea" */ "@/uni_modules/uview-ui/components/u--textarea/u--textarea.vue"
      )
    },
    uPopup: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-popup/u-popup" */ "@/uni_modules/uview-ui/components/u-popup/u-popup.vue"
      )
    },
    uCell: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-cell/u-cell" */ "@/uni_modules/uview-ui/components/u-cell/u-cell.vue"
      )
    },
    uButton: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-button/u-button" */ "@/uni_modules/uview-ui/components/u-button/u-button.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.indexList.length
  var l0 =
    g0 > 0
      ? _vm.__map(_vm.indexList, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m0 = _vm.getPositionStr(item.position)
          var m1 = _vm.auditStatus(item.auditStatus)
          return {
            $orig: $orig,
            m0: m0,
            m1: m1,
          }
        })
      : null
  var m2 = _vm.activeItem.position
    ? _vm.getPositionStr(_vm.activeItem.position)
    : null
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.show = false
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        l0: l0,
        m2: m2,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }